export interface CarrierCompanyDetails {
  id: string;
  createDateTime?: string;
  createdBy?: string;
  lastChangedDateTime?: string;
  lastChangedBy?: string;
  isActive?: boolean;
  tags?: string[] | null;
  name?: string;
  scac?: string | null;
  mc?: string | null;
  usdot?: string | null;
  type?: string;
}

export interface CarrierUserDetails {
  id: string;
  company?: CarrierCompanyDetails | null;
  companyId?: string;
  createDateTime?: string;
  createdBy?: string;
  email?: string;
  extension?: string | null;
  firstName?: string;
  lastName?: string;
  invalidLoginAttempts?: number | null;
  isActive?: boolean;
  isEmailVerified?: boolean;
  lastChangedBy?: string;
  lastChangedDateTime?: string;
  lastLoginAt?: string | null;
  name?: string;
  orgId?: string | null;
  phone?: string | null;
  role?: string;
  tags?: string[] | null;
  tcConfirmedAt?: string | null;
  warehouseAccessList?: unknown;
}

export function normalizeCarrier(response: unknown): CarrierUserDetails | null {
  if (!response) {
    return null;
  }

  if (Array.isArray(response)) {
    return (response[0] as CarrierUserDetails) ?? null;
  }

  if (typeof response === 'object' && response !== null) {
    const maybeItems = (response as { items?: unknown }).items;
    if (Array.isArray(maybeItems)) {
      return (maybeItems[0] as CarrierUserDetails) ?? null;
    }

    return response as CarrierUserDetails;
  }

  return null;
}
